import React from 'react';
import footer_bg from '../images/footer-bg.jpg'
import './Footer.css'

export default function Footer(){
   return(
        <div className='footer'>
           <img className='footer-bg' src={footer_bg} alt='footer-bg'/>
           <p className='footer-text'>
              国勘数字地球（北京）科技有限公司<br/>
              Geological&nbsp;Survey Digital Earth(BeiJing)Technology Co.,Ltd.<br/>
              地址：北京市海淀区中科智汇工场
           </p>
        </div>
   )
}